import React, { Component } from "react"
import { translate } from "react-i18next"
import PropTypes from "prop-types"
import styled from "styled-components"
import ScrollBars from "react-custom-scrollbars"
import { Button } from "../../../themed-html-components"
import Tabs from "../../../layout/navigation/Tabs"
import CustomReportFormPageDetails from "./CustomReportFormPageDetails"
import { WorkflowStepShape } from "../../../../state/shapes/CustomReportShapes"

const CustomReportFormQuestionContainer = styled.div`
  position: relative;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  min-width: 0;
  min-height: 300px;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-top: none;
  padding-top: 1em;
  padding-left: 1em;
`

class CustomReportReviewDetails extends Component {
  state = {
    selectedQuestions: [],
    confirmButtonDisabled: true,
  }

  addSelectedQuestions = (questions) => {
    const questionsToAdd = []
    const array = [...this.state.selectedQuestions]

    if (questions.length !== undefined) {
      questions.map((question, i) => {
        question.checked = true

        // Need to ensure no duplication of questions end up in selectedQuestions.
        const index = array.indexOf(question)
        if (index === -1) {
          questionsToAdd.push(question)
        }
      }, this)
    } else {
      questions.checked = true

      const index = array.indexOf(questions)
      if (index === -1) {
        questionsToAdd.push(questions)
      }
    }

    // Now that a question has been selected we can enable the confirm button.
    this.setState({
      selectedQuestions: [...this.state.selectedQuestions, ...questionsToAdd],
      confirmButtonDisabled: false,
    })
  }

  removeSelectedQuestions = (questions) => {
    const array = [...this.state.selectedQuestions]

    if (questions.length !== undefined) {
      questions.map((question, i) => {
        question.checked = false

        // Need to ensure no duplication of questions end up in selectedQuestions.
        const index = array.indexOf(question)
        if (index !== -1) {
          array.splice(index, 1)
        }
      }, this)
    } else {
      questions.checked = false

      const index = array.indexOf(questions)
      if (index !== -1) {
        array.splice(index, 1)
      }
    }

    this.setState({ selectedQuestions: [...array], confirmButtonDisabled: array.length === 0 })
  }

  confirm = () => {
    this.props.resetWarningMessage()

    this.state.selectedQuestions.map((question) => {
      this.props.questionSelected(question.questionId, question.clientWorkflowStepId, null)
    }, this)

    this.setState({ selectedQuestions: [], confirmButtonDisabled: true })
    this.props.clearCheckboxes()
  }
  render() {
    const {
      reviewData, tabClicked, activeTab, questionSelected, t,
    } = this.props
    const { confirmButtonDisabled } = this.state
    const mappedTabs = reviewData.map((stage) => {
      return { id: stage.clientWorkflowStepId, name: stage.nameTranslationIdentifier }
    })

    return (
      <div>
        <Tabs
          tabDetails={mappedTabs}
          onTabChange={tabClicked}
          activeTab={activeTab}
          charactersToDisplay={20}
          smallTabHeaderText
        />

        <CustomReportFormQuestionContainer>
          <ScrollBars autoHeight autoHeightMin={230}>
            {reviewData
              .filter((item) => {
                return item.clientWorkflowStepId === activeTab
              })
              .map((filteredItem) => {
                return filteredItem.pages.map((page) => {
                  return (
                    <CustomReportFormPageDetails
                      page={page}
                      key={`${page.clientWorkflowStepId}_${page.formPageId}`}
                      questionSelected={questionSelected}
                      addSelectedQuestions={this.addSelectedQuestions}
                      removeSelectedQuestions={this.removeSelectedQuestions}
                    />
                  )
                })
              })}
          </ScrollBars>
          <div
            className="row"
            style={{
              marginTop: "10px",
              marginRight: "0px",
              backgroundColor: "#E8E8E8",
              paddingTop: "10px",
              paddingBottom: "10px",
            }}
          >
            <hr />
            <div className="col-md-9" style={{ fontSize: "14px" }}>
              {t("Common.ClickToMove1")} ({this.state.selectedQuestions.length}{" "}
              {t("Common.ClickToMove2")})
            </div>
            <div className="col-md-3">
              <Button inverted onClick={this.confirm} disabled={confirmButtonDisabled}>
                {t("Common.Confirm")}
              </Button>
            </div>
          </div>
        </CustomReportFormQuestionContainer>
      </div>
    )
  }
}

CustomReportReviewDetails.propTypes = {
  tabClicked: PropTypes.func.isRequired,
  activeTab: PropTypes.number.isRequired,
  reviewData: PropTypes.arrayOf(PropTypes.shape(WorkflowStepShape)).isRequired,
  questionSelected: PropTypes.func.isRequired,
  clearCheckboxes: PropTypes.func.isRequired,
  resetWarningMessage: PropTypes.func.isRequired,
}
export default translate()(CustomReportReviewDetails)



// WEBPACK FOOTER //
// ./src/components/custom-report/Modals/QuestionSelection/CustomReportReviewDetails.jsx